export default __webpack_public_path__ + "static/media/paintswap.c6f99ae8.svg";